import { useBuilderState } from '../../hooks/useBuilderState';
import { useBuilderStore } from '../../store/builderStore';

const SurfaceTabs = () => {
  const {
    currentSurface,
    productConfig,
    setCurrentSurface,
    setSelectedNodeId,
  } = useBuilderState();
  const surfaces = useBuilderStore((s) => s.surfaces);

  const getSurfaceLabel = (surface: string) => {
    if (productConfig.surfaceLabels?.[surface]) return productConfig.surfaceLabels[surface];
    switch (surface) {
      case "front": return "Front";
      case "back": return "Back";
      case "leftSleeve": return "Left Sleeve";
      case "rightSleeve": return "Right Sleeve";
      case "collar": return "Collar";
      default: return surface;
    }
  };

  return (
    <div className="relative z-2 flex items-center gap-0.5 border rounded-full bg-white shadow-sm px-1 py-1">
      {productConfig.surfaces.map((surface) => (
        <button
          key={surface}
          onClick={() => {
            setCurrentSurface(surface);
            setSelectedNodeId(null);
          }}
          className={`relative px-2 py-0.5 text-xs font-medium rounded-md transition-colors ${
            currentSurface === surface
              ? "text-gray-900 bg-gray-100"
              : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
          }`}
        >
          {getSurfaceLabel(surface)}
          {surfaces[surface]?.length > 0 && (
            <span className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-blue-500" />
          )}
        </button>
      ))}
    </div>
  );
};

export { SurfaceTabs };
